const C = "USER.NEW"

export const SUBMIT = `${C}.SUBMIT`
export const SUBMIT_COMPLETED = `${C}.SUBMIT_COMPLETED`
export const SUBMIT_FAILED = `${C}.SUBMIT_FAILED`
